import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import styled from "styled-components/macro";

import { faSyncAlt } from "@fortawesome/pro-duotone-svg-icons";
import { motion } from "framer-motion";

import FnrTooltip from "UI/FnrTooltip2";

import { formatCurrencyWithCommas } from "Utilities/Number";

export default function PastPledge({
  pledgeID,
  campaignName,
  householdID,
  totalPledged,
  amountGiven,
  intervalDescription,
  amountPerInterval = 0,
  fundColor,
  status,
  hasRecurring,
}) {
  let progressWidth = 0;
  let borderWidth = 0;

  if (amountGiven < totalPledged) {
    progressWidth = amountGiven / totalPledged;
    borderWidth = 100;
  } else {
    progressWidth = 1;
    borderWidth = (totalPledged / amountGiven) * 100;
  }

  return (
    <Wrapper>
      <Info>
        <Campaign>{campaignName}</Campaign>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <Amount>
            ${formatCurrencyWithCommas(amountPerInterval, false)} /{" "}
            {intervalDescription}
          </Amount>
          {hasRecurring ? (
            <FnrTooltip content="This pledge has an associated recurring gift.">
              <FontAwesomeIcon icon={faSyncAlt} />
            </FnrTooltip>
          ) : null}
        </div>
      </Info>
      <ProgressBarContainer>
        <ProgressBarBorder
          style={
            status === "closed"
              ? {
                  background: "var(--pledgesProgressBarBackground)",
                  width: borderWidth + "%",
                }
              : { width: borderWidth + "%" }
          }
        />
        {amountGiven > 0 && (
          <ProgressBar
            style={{
              background: fundColor,
              width: "calc((100% - 4px) * " + progressWidth + ")",
            }}
          />
        )}
      </ProgressBarContainer>
    </Wrapper>
  );
}

const Wrapper = styled(motion.div)`
  padding: 12px;
  border-radius: 18px;
  color: var(--pledgesTextColor);
  cursor: pointer;
  position: relative;
  z-index: 100;
`;

const Info = styled.div`
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  padding: 0 4px 2px 4px;
`;
const Campaign = styled.div`
  font-size: 18px;
`;
const Amount = styled.div`
  margin-left: 20px;
  font-size: 17px;
  flex-shrink: 0;
`;

const ProgressBarBorder = styled.div`
  border: 1px solid #828c8d;
  border-radius: 20px;
  padding: 1px;
  box-sizing: border-box;
  height: 12px;

  width: 100%;
  background-color: #f6f7f8;
`;
const ProgressBar = styled.div`
  height: 8px;
  border-radius: 8px;
  position: absolute;
  left: 2px;
`;
const ProgressBarContainer = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  margin-top: 4px;
`;
